<template>
  <div class="service-types d-flex flex-wrap">
    <p class="sr-only">View similar services by service type:</p>
    <span v-for="(item, index) in listArray" :key="index" class="mr-1">
      <router-link
        v-if="parentName"
        :to="{
          name: 'Search',
          query: {
            [termName(item[parentName].vocabulary)]: item[parentName].id,
          },
        }"
        :aria-label="item[parentName][valueName]"
        class="badge badge-pill btn btn-outline-primary font-weight-normal"
      >
        <span
          v-if="parentName"
          @click="goTerm(termName(item[parentName].vocabulary), item[parentName].id)"
        >
          {{ item[parentName][valueName] }}
        </span>
      </router-link>

      <span v-if="!parentName">{{ item[valueName] }} </span>
    </span>
  </div>
</template>

<script>
import store from '@/store/'
import { SEND_FILTER_SELECTED } from '../../store/actions.type'

export default {
  name: 'ListInfo',
  props: {
    parentName: {
      type: String,
      default: '',
    },
    idName: {
      type: String,
      default: '',
    },
    valueName: {
      type: String,
      default: '',
    },
    listArray: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    termName(vocab) {
      if (vocab == 'esdServiceTypes') {
        return 'service_type'
      }
      if (vocab.includes('esd')) {
        return vocab.substring(3).toLowerCase().slice(0, -1)
      }
      return vocab
    },
    goTerm(paramId, value) {
      store.dispatch(SEND_FILTER_SELECTED, {
        paramId: paramId,
        selected: value,
      })
    },
  },
}
</script>
